import { render } from "./Authenticator.vue?vue&type=template&id=31a7ae6c&scoped=true"
import script from "./Authenticator.vue?vue&type=script&lang=js"
export * from "./Authenticator.vue?vue&type=script&lang=js"

import "./Authenticator.vue?vue&type=style&index=0&id=31a7ae6c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31a7ae6c"]])

export default __exports__